export default function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="loader is-large"></div>
    </div>
  );
}
